<template>
  <div class="popularize">
      <img class="top-banner" :src="`${GET_STATIC_IMG_HOST}popularize/others/banner1.jpg`">
      <div class="content-wrapper">
          <div class="top-context">
              <p>有声的紫襟、大斌、章鱼讲故事，这些你爱的声音创作者都来自喜马拉雅作品有声化平台，从默默无名的有声爱好者，慢慢成长拥有百万粉丝的主播大神</p>
              <p>加入我们，下一个大神也许就是你……</p>
          </div>
          <div class="separate-line"></div>
          <div class="best-anchor">
              <a href="http://www.ximalaya.com/zhubo/1266964/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day1/有声的紫襟.jpg`" class="anchor-head"></a>
              <div class="right-wrapper">
                  <a href="http://www.ximalaya.com/zhubo/1266964/" class="anchor-name">有声的紫襟</a>
                  <div class="works-wrapper">
                      <a href="http://www.ximalaya.com/1266964/album/4756811/" class="work">
                          <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/摸金天师.jpg`" class="work-cover">
                          <span class="work-name">摸金天师</span>
                      </a>
                      <a href="http://www.ximalaya.com/1266964/album/9877679/" class="work">
                          <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/狠人狠事.jpg`" class="work-cover">
                          <span class="work-name">狠人狠事</span>
                      </a>
                      <a href="http://www.ximalaya.com/1266964/album/8625924/" class="work">
                          <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/我当摸金校尉的那些年.jpg`" class="work-cover">
                          <span class="work-name">我当摸金校尉的那些年</span>
                      </a>
                      <a href="http://www.ximalaya.com/1266964/album/2991915/" class="work">
                          <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/武动乾坤.jpg`" class="work-cover">
                          <span class="work-name">武动乾坤</span>
                      </a>
                      <a href="http://www.ximalaya.com/1266964/album/3888524/" class="work">
                          <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/麻衣神算子.jpg`" class="work-cover">
                          <span class="work-name">麻衣神算子</span>
                      </a>
                  </div>
                  <span class="desc">喜马拉雅FM超人气王牌主播，一个不好好当程序员的野生主播。声音磁性，演播方式多变，擅长恐怖悬疑类小说，在喜马拉雅已获得300多万粉丝，长期霸榜全球华语博客巅峰榜</span>
              </div>
          </div>
          <div class="separate-line"></div>
          <div class="top-anchors-wrapper">
              <span class="title">- 他们都在这里 -</span>
              <div class="top-anchors-row">
                  <div class="top-anchor">
                      <div class="top-anchor-top">
                          <a href="http://www.ximalaya.com/zhubo/2342717/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day1/大斌.jpg`"></a>
                          <div class="top-anchor-right">
                              <a href="http://www.ximalaya.com/zhubo/2342717/" class="anchor-name">大斌</a>
                              <div class="works-wrapper">
                                  <a href="http://www.ximalaya.com/2342717/album/2684034/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/雪中悍刀行.jpg`">
                                      <span class="work-name">雪中悍刀行</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/2342717/album/5363322/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/猎灵师.jpg`">
                                      <span class="work-name">猎灵师</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/2342717/album/3551440/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/龙蛇演义.jpg`">
                                      <span class="work-name">龙蛇演义</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <span class="desc">调频广播主持人、喜马拉雅签约白金主播，以其独特的风格、代入感广受受众喜爱</span>
                  </div>
                  <div class="top-anchor">
                      <div class="top-anchor-top">
                          <a href="http://www.ximalaya.com/zhubo/6333535/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day1/泡芙先生.jpg`"></a>
                          <div class="top-anchor-right">
                              <a href="http://www.ximalaya.com/zhubo/6333535/" class="anchor-name">泡芙先生</a>
                              <div class="works-wrapper">
                                  <a href="http://www.ximalaya.com/6333535/album/2696006/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/心理罪.jpg`">
                                      <span class="work-name">心理罪</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/6333535/album/3131043/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/陈二狗的妖孽人生.jpg`">
                                      <span class="work-name">陈二狗的妖孽人生</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/6333535/album/8215306/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/我混江湖的那些年.jpg`">
                                      <span class="work-name">我混江湖的那些年</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <span class="desc">喜马拉雅签约主播。演绎风格独特，作品风格以悬疑灵异类以及都市类小说为主。其演播方式赢得广大听友的肯定和支持。在喜马拉雅FM已获得100万+粉丝，作品拥有超过5亿+的播放量与下载量。</span>
                  </div>
              </div>
              <div class="top-anchors-row">
                  <div class="top-anchor">
                      <div class="top-anchor-top">
                          <a href="http://www.ximalaya.com/zhubo/2642819/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day1/章鱼讲故事.jpg`"></a>
                          <div class="top-anchor-right">
                              <a href="http://www.ximalaya.com/zhubo/2642819/" class="anchor-name">章鱼讲故事</a>
                              <div class="works-wrapper">
                                  <a href="http://www.ximalaya.com/2642819/album/2688124/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/罗布泊之咒.jpg`">
                                      <span class="work-name">罗布泊之咒</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/2642819/album/425648/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/无证之罪.jpg`">
                                      <span class="work-name">无证之罪</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/2642819/album/3969624/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/我是阴阳人.jpg`">
                                      <span class="work-name">我是阴阳人</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <span class="desc">演播风格层次分明，逻辑清晰，很容易将人带入情境，画面感非常强。对人物角色把握到位，人物对话辨识感很强</span>
                  </div>
                  <div class="top-anchor">
                      <div class="top-anchor-top">
                          <a href="http://www.ximalaya.com/zhubo/4932085/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day1/丸子.jpg`"></a>
                          <div class="top-anchor-right">
                              <a href="http://www.ximalaya.com/zhubo/4932085/" class="anchor-name">丸子</a>
                              <div class="works-wrapper">
                                  <a href="http://www.ximalaya.com/4932085/album/3160816/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/超品相师.jpg`">
                                      <span class="work-name">超品相师</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/4932085/album/2760075/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/风水鬼师.jpg`">
                                      <span class="work-name">风水鬼师</span>
                                  </a>
                                  <a href="http://www.ximalaya.com/4932085/album/2799378/" class="work">
                                      <img :src="`${GET_STATIC_IMG_HOST}popularize/day1/校花的贴身高手.jpg`">
                                      <span class="work-name">校花的贴身高手</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <span class="desc">喜马拉雅FM人气主播，小说演播者，网红，游戏设计师。主播丸子于2014年至今，演播了多部多类型的网络有声小说。喜马拉雅FM粉丝破100万，播放量以及下载量近8亿，演播风格独具一格。</span>
                  </div>
              </div>
          </div>
          <div class="separate-line"></div>
          <div class="more-wrapper">
              <span class="title">- 了解更多 -</span>
              <div class="links-wrapper">
                  <router-link class="link" :to="{name: 'classic'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/经典汇聚@2x.png`"></router-link>
                  <router-link class="link" :to="{name: 'workLib'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/海量作品@2x.png`"></router-link>
                  <router-link class="link" :to="{name: 'benefits'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/福利体系@2x.png`"></router-link>
              </div>
          </div>
          <router-link :to="{name: 'anchorIndex'}" class="btn-join-bottom">立即加入</router-link>
          <router-link :to="{name: 'anchorIndex'}" class="btn-join-fixed">立即加入</router-link>
      </div>
  </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    methods: {
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台首页"
        }),
          xmLog("pv.send", "event", {
            serviceId: "aBookView",
            item: "有声化推广页_大神云集"
          })
      }
    },
    computed: {
      GET_STATIC_IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    },
    mounted () {
      // 埋点
      this.setXMLog ();
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/popularize/popularize-first.scss";
</style>



// WEBPACK FOOTER //
// Idols.vue?2a693427